module.exports = __webpack_public_path__ + "img/jianpai.3450da0b.png";